/** What `session.workspace` carries — `SessionWorkspace.Workspace` on the backend. */
export type TermKey = 'resource' | 'trial' | 'customer' | 'location'

export interface Term {
  singular: string
  plural: string
}

export interface Workspace {
  displayName: string
  /** `#rrggbb`, lower case. */
  brandColor: string
  /** `/api/workspace/logo?v=…`, or null without a logo. */
  logoUrl: string | null
  terms: Record<TermKey, Term>
}

export const TERM_KEYS: readonly TermKey[] = ['resource', 'trial', 'customer', 'location']

/** The backend's `TermKey` defaults; used while no session says otherwise. */
export const DEFAULT_TERMS: Record<TermKey, Term> = {
  resource: { singular: 'Ressource', plural: 'Ressourcen' },
  trial: { singular: 'Probetermin', plural: 'Probetermine' },
  customer: { singular: 'Kunde', plural: 'Kunden' },
  location: { singular: 'Standort', plural: 'Standorte' },
}

export const DEFAULT_DISPLAY_NAME = 'Studio Workspace'

export const DEFAULT_BRAND_COLOR = '#4a5d7e'
